import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { coalesce } from "../../../../utils/ObjectUtils";

import Choice from "../Choice";
import QuestionHeader from "./QuestionHeader";

const TableQuestion = ({
  changeQuestionField,
  pageName,
  question,
  addQuestionChoice,
  removeQuestionChoice,
  reorderChoice,
  editSubchoice,
  confirmSubchoice,
  cancelSubchoice,
  setValidator,
  setValidatorProperty,
  loadPredefinedList,
  loadIndicators,
  addIndicatorToQuestion,
  removeIndicatorFromQuestion,
  allIndicators,
  intl,
  libraryQuestion,
  isAdminUser
}) => (
  <QuestionHeader
    changeQuestionField={changeQuestionField}
    pageName={pageName}
    question={question}
    intl={intl}
    addIndicatorToQuestion={addIndicatorToQuestion}
    removeIndicatorFromQuestion={removeIndicatorFromQuestion}
    loadIndicators={loadIndicators}
    allIndicators={allIndicators}
    libraryQuestion={libraryQuestion}
  >
    <>
      <h6>
        <FormattedMessage id="survey.editor.matrix.column.choices" />
      </h6>
      {question.columns.map((choice, i) => {
        const choiceName = coalesce(choice.name, choice.value);
        return (
          <Choice
            key={choiceName}
            editable={isAdminUser || !choice.unchangeable}
            required={choice.required}
            visible={choice.visible !== false}
            choiceName={choiceName}
            choiceText={choice.text}
            choiceKey={choice.key}
            changeQuestionField={changeQuestionField}
            question={question}
            pageName={pageName}
            addQuestionChoice={addQuestionChoice}
            removeQuestionChoice={removeQuestionChoice}
            choiceTarget="columns"
            hasSubchoice
            type={choice.type}
            editSubchoice={editSubchoice}
            confirmSubchoice={confirmSubchoice}
            cancelSubchoice={cancelSubchoice}
            reorderChoice={reorderChoice}
            infoText={choice.infoText}
            choiceDescriptionVisible={choice.choiceDescriptionVisible}
            letter={65 + i}
            setValidator={setValidator}
            setValidatorProperty={setValidatorProperty}
            loadPredefinedList={loadPredefinedList}
          />
        );
      })}
    </>
    {question.type !== "dynamicTable" && (
      <>
        <h6>
          <FormattedMessage id="survey.editor.matrix.row.choices" />
        </h6>
        {question.rows.map((choice, i) => {
          let choiceName = coalesce(choice.name, choice.value);
          return (
            <Choice
              editable={isAdminUser || !choice.unchangeable}
              required={choice.required}
              key={choiceName}
              choiceName={choiceName}
              choiceText={choice.text}
              choiceKey={choice.key}
              changeQuestionField={changeQuestionField}
              question={question}
              pageName={pageName}
              addQuestionChoice={addQuestionChoice}
              removeQuestionChoice={removeQuestionChoice}
              choiceTarget="rows"
              reorderChoice={reorderChoice}
              infoText={choice.infoText}
              choiceDescriptionVisible={choice.choiceDescriptionVisible}
              letter={65 + i}
              loadPredefinedList={loadPredefinedList}
            />
          );
        })}
      </>
    )}
  </QuestionHeader>
);
export default TableQuestion;

TableQuestion.propTypes = {
  changeQuestionField: PropTypes.func,
  setValidator: PropTypes.func,
  addQuestionChoice: PropTypes.func,
  reorderChoice: PropTypes.func,
  removeQuestionChoice: PropTypes.func,
  confirmSubchoice: PropTypes.func,
  editSubchoice: PropTypes.func,
  cancelSubchoice: PropTypes.func,
  setValidatorProperty: PropTypes.func,
  loadPredefinedList: PropTypes.func,
  pageName: PropTypes.string,
  question: PropTypes.object,
  loadIndicators: PropTypes.func,
  addIndicatorToQuestion: PropTypes.func,
  removeIndicatorFromQuestion: PropTypes.func,
  intl: PropTypes.object,
  allIndicators: PropTypes.array,
  libraryQuestion: PropTypes.object
};
